import React from 'react'
import CenteredWidget from '@vero/ui-components/components/centered-widget.jsx'
import AuthedPage from '../pages/authed-page.jsx'
import ChangePassword from '../widgets/change-password.jsx'

export default function ({ title, children }) {
  return (
    <AuthedPage title={title}>
      <CenteredWidget title={title} Widget={ChangePassword} className='auth-bg'>
        {children}
      </CenteredWidget>
    </AuthedPage>
  )
}
